import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { Icon } from "@sportal/cdk";

import { useIntlTranslate } from "../../hooks";

export const useExternalLink = () => {
  const target = "_blank";
  const openExternalLink = (url) => window.open(url, target);

  return [openExternalLink, target];
};

export const ExternalLink = ({ className, url, children, ...attr }) => {
  const [, target] = useExternalLink();
  const translate = useIntlTranslate();

  return (
    <a
      className={classnames("link link--external", className)}
      target={target}
      href={url}
      rel="noopener noreferrer"
      aria-label={translate("aria_external_link", { linkText: children })}
      {...attr}
    >
      <span>{children}</span>
      <Icon icon="fa-regular fa-square-up-right" />
    </a>
  );
};

ExternalLink.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
